import React, { useEffect } from 'react';
import { HeaderGlobal, Breadcrumb } from 'src/components';
import { Link } from 'react-router-dom';
import {
    setDataInfoGraphics,
} from 'src/config/redux/action/';
import { useSelector, useDispatch } from 'react-redux';
import Skeleton from 'react-loading-skeleton';
import { ILEmptyGrafis } from 'src/assets/image';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import { Helmet } from "react-helmet";

const InfoGrafis = ({ ...props }) => {
    const { dataInfoGraphics } = useSelector(state => state.infoGraphicReducer)
    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(setDataInfoGraphics())
        window.scrollTo({ top: 0, behavior: "smooth" })
    }, [dispatch])

    return (
        <>
            <Helmet>
                <meta charSet='utf-8' />
                <title>{`Info Grafis | Portal SATU DATA KABUPATEN SIGI`}</title>
                <meta name='description' content={`Info Grafis | Portal SATU DATA KABUPATEN SIGI`} />
            </Helmet>
            <div className="site-main">
                <HeaderGlobal />
                <section className="ttm-row aboutus-section ttm-bgcolor-grey clearfix">
                    <div className="container-xl mt-4 res-767-mt-0">

                        {/* BREADCUMB */}
                        <Breadcrumb crumbs={props.crumbs} />
                        {/* BREADCUMB */}

                        <section className="sidebar ttm-sidebar ttm-bgcolor-grey clearfix">
                            <div className="container-xl">
                                <div className="row">
                                    <div className="col-lg-12">
                                        <div className="section-title with-desc text-center clearfix">
                                            <div className="title-header mt-5">
                                                <h2 className="title">Telusuri Info Grafis</h2>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="row">
                                    {
                                        dataInfoGraphics ?
                                            dataInfoGraphics.length !== 0 ?
                                                dataInfoGraphics.map((v, i) => {
                                                    return (
                                                        <div key={i} className="col-lg-4 col-md-6">
                                                            <div className="featured-imagebox featured-imagebox-blog style2 mb-30" style={{minHeight:'460px'}}>
                                                                <div className="featured-thumbnail text-center">
                                                                    <LazyLoadImage
                                                                        className="img-fluid"
                                                                        effect="blur"
                                                                        src={v.UrlThumbnail}
                                                                        style={{ width: '300px', height: '300px', objectFit: 'cover' }} 
                                                                    />
                                                                    <div className="ttm-blog-overlay-iconbox">
                                                                        <Link to={`/info-grafis/detail/${v.Slug}`}><i className="ti ti-plus" /></Link>
                                                                    </div>
                                                                    <div className="ttm-box-view-overlay" />
                                                                </div>
                                                                <div className="featured-content">
                                                                    <div className="ttm-box-post-date">
                                                                        <span className="ttm-entry-date">
                                                                            <time className="entry-date" dateTime="2019-01-161T07:07:55+00:00">{v.CreatedDateDay}<span className="entry-month entry-year">{v.CreatedDateMonth}</span></time>
                                                                        </span>
                                                                    </div>
                                                                    <div className="featured-title">
                                                                        <h6><Link to={`/info-grafis/detail/${v.Slug}`} style={{ WebkitLineClamp: 2, textOverflow: 'ellipsis', display: '-webkit-box', WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>{v.Title}</Link></h6>
                                                                    </div>
                                                                    <div className="featured-desc">
                                                                        <p style={{ WebkitLineClamp: 2, textOverflow: 'ellipsis', display: '-webkit-box', WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>
                                                                            {v.Description}
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )
                                                })
                                                :
                                                <div className="col-md-12 text-center mt-5">
                                                    <img src={ILEmptyGrafis} className={'img-fluid'} width={400} /> <br />
                                                    <div className='mt-4'>
                                                        <span>Info grafis tidak ditemukan!</span>
                                                    </div>
                                                </div>
                                            :
                                            <>
                                                <div className="col-md-4">
                                                    <Skeleton height={300} width={'100%'} />
                                                    <div className="mt-2">
                                                        <Skeleton width={'80%'} />
                                                        <Skeleton width={'60%'} />
                                                    </div>
                                                </div>
                                                <div className="col-md-4">
                                                    <Skeleton height={300} width={'100%'} />
                                                    <div className="mt-2">
                                                        <Skeleton width={'80%'} />
                                                        <Skeleton width={'60%'} />
                                                    </div>
                                                </div>
                                                <div className="col-md-4">
                                                    <Skeleton height={300} width={'100%'} />
                                                    <div className="mt-2">
                                                        <Skeleton width={'80%'} />
                                                        <Skeleton width={'60%'} />
                                                    </div>
                                                </div>
                                            </>
                                    }

                                </div>
                            </div>
                        </section>

                    </div>
                </section>
            </div>
            </>
    )
}

export default InfoGrafis;